export function isProductDisclaimerEmpty(props) {
    return !props?.type;
}
